module.exports = __webpack_public_path__ + "img/baners.2cf0d8a8.jpg";